// Main checkout component
import CheckoutFooter from './CheckoutFooter/CheckoutFooter';
import CheckoutHeader from './CheckoutHeader/CheckoutHeader';
import CheckoutPayment from './CheckoutPayment/CheckoutPayment';
import CheckoutPricing from './CheckoutPricing/CheckoutPricing';
import CheckoutRoot from './CheckoutRoot/CheckoutRoot';
import FreeTrialInfo from './FreeTrialInfo/FreeTrialInfo';
import PriceDisplay from './PriceDisplay/PriceDisplay';
import PriceLineItem from './PriceLineItem/PriceLineItem';
import PriceSummary from './PriceSummary/PriceSummary';

export const Checkout = {
  // Section components
  Root: CheckoutRoot,
  Header: CheckoutHeader,
  Pricing: CheckoutPricing,
  Payment: CheckoutPayment,
  Footer: CheckoutFooter,
  // Pricing components
  PriceDisplay,
  PriceLineItem,
  PriceSummary,
  FreeTrialInfo,
};

// Types
export type * from './types';
